module.exports = __webpack_public_path__ + "media/images/sent-img-msg-e47d78e559f0425f918d05185105461de3042c911def11beb7da21691aefe5ac.png";